(() => {
  const SIZES = [
    { key: "twin", label: "Twin" },
    { key: "twinxl", label: "Twin XL" },
    { key: "full", label: "Full" },
    { key: "fullxl", label: "Full XL" },
    { key: "queen", label: "Queen" },
    { key: "king", label: "King" },
  ];

  const PRESETS = {
    single_fitted: { flat: 0, fitted: 1, pillowcases: 2 },
    single_flat: { flat: 1, fitted: 0, pillowcases: 2 },
    double_flat: { flat: 2, fitted: 0, pillowcases: 2 },
    double_fitted_flat: { flat: 1, fitted: 1, pillowcases: 2 },
    triple_flat3: { flat: 3, fitted: 0, pillowcases: 2 },
    triple_fitted_2flat: { flat: 2, fitted: 1, pillowcases: 2 },
  };

  function clamp(n, min, max) {
    n = Number.isFinite(n) ? n : 0;
    return Math.min(max, Math.max(min, n));
  }
  const roundInt = (n) => Math.round(n);
  const fmt = (n) => Math.max(0, roundInt(n)).toLocaleString();

  function parSuggestionFromOcc(occPct) {
    if (occPct >= 85) return 4;
    if (occPct >= 60) return 3;
    if (occPct >= 30) return 2;
    return 1;
  }

  function buildCopyText(state, outputs) {
    const lines = [];
    lines.push("Linen Inventory Planning Results", "");
    lines.push("Beds in service by size:");
    SIZES.forEach(s => lines.push(`- ${s.label}: ${state.bedsBySize[s.key]}`));
    lines.push("");
    lines.push(`Average occupancy: ${roundInt(state.occPct)}%`);
    lines.push(`Target par level: ${roundInt(state.par)}`);
    lines.push(`Safety reserve: ${roundInt(state.bufferPct)}%`);
    lines.push(`Items per bed: Flat ${roundInt(state.flatPerBed)}, Fitted ${roundInt(state.fittedPerBed)}, Pillowcases ${roundInt(state.pcasesPerBed)}`);
    lines.push("");
    lines.push("Recommended inventory by size:");
    SIZES.forEach(s => {
      const o = outputs.bySize[s.key];
      lines.push(`${s.label}: Flats ${fmt(o.flat)}, Fitted ${fmt(o.fitted)}, Pillowcases ${fmt(o.pillowcases)} (Total ${fmt(o.total)})`);
    });
    lines.push("");
    lines.push(`Totals: Flats ${fmt(outputs.totals.flat)}, Fitted ${fmt(outputs.totals.fitted)}, Pillowcases ${fmt(outputs.totals.pillowcases)} (All ${fmt(outputs.totals.all)})`);
    return lines.join("\n");
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-linen-par-section]").forEach(section => {
      const root = section.querySelector("[data-linen-par]");
      if (!root) return;

      const els = {
        stepPills: Array.from(root.querySelectorAll("[data-step-pill]")),
        steps: Array.from(root.querySelectorAll("[data-step]")),
        nextBtns: Array.from(root.querySelectorAll("[data-step-next]")),
        prevBtns: Array.from(root.querySelectorAll("[data-step-prev]")),

        preset: root.querySelector("[data-linen-par-preset]"),
        occ: root.querySelector("[data-linen-par-occupancy]"),
        par: root.querySelector("[data-linen-par-par]"),
        buffer: root.querySelector("[data-linen-par-buffer]"),
        flat: root.querySelector("[data-linen-par-flat]"),
        fitted: root.querySelector("[data-linen-par-fitted]"),
        pcases: root.querySelector("[data-linen-par-pillowcases]"),
        bedsSizeInputs: Array.from(root.querySelectorAll("[data-linen-par-beds-size]")),

        outTotalBeds: root.querySelector("[data-linen-par-totalBeds]"),
        outActiveBeds: root.querySelector("[data-linen-par-activeBeds]"),

        outCells: Array.from(root.querySelectorAll("[data-linen-par-out]")),
       outTotalsFlat: Array.from(root.querySelectorAll('[data-linen-par-out-total="flat"]')),
        outTotalsFitted: Array.from(root.querySelectorAll('[data-linen-par-out-total="fitted"]')),
        outTotalsPcases: Array.from(root.querySelectorAll('[data-linen-par-out-total="pillowcases"]')),
        outTotalsAll: Array.from(root.querySelectorAll('[data-linen-par-out-total="all"]')),

        parSuggestion: root.querySelector("[data-linen-par-parSuggestion]"),

        // bind ALL buttons (left step 3 + right panel)
        resetBtns: Array.from(root.querySelectorAll("[data-linen-par-reset]")),
        copyBtns: Array.from(root.querySelectorAll("[data-linen-par-copy]")),
        printBtns: Array.from(root.querySelectorAll("[data-linen-par-print]")),
        copyStatus: root.querySelector("[data-linen-par-copyStatus]"),

        occInfoBtn: root.querySelector("[data-linen-par-occInfoBtn]"),
        occTooltip: root.querySelector("[data-linen-par-occTooltip]"),
      };

      // tag -> [cells] because we have mobile + desktop tables
      const outMapMulti = new Map();
      els.outCells.forEach(cell => {
        const tag = cell.getAttribute("data-linen-par-out");
        if (!tag) return;
        const arr = outMapMulti.get(tag) || [];
        arr.push(cell);
        outMapMulti.set(tag, arr);
      });

      function setStep(stepNum) {
        const s = String(stepNum);
        root.setAttribute("data-linen-step", s);

        els.steps.forEach(panel => {
          const isActive = panel.getAttribute("data-step") === s;
          panel.classList.toggle("is-active", isActive);
          panel.hidden = !isActive;
        });

        els.stepPills.forEach(pill => {
          const isActive = pill.getAttribute("data-step-pill") === s;
          pill.classList.toggle("is-active", isActive);
          pill.setAttribute("aria-selected", isActive ? "true" : "false");
        });

       
      }

      function getBedsBySize() {
        const bedsBySize = {};
        SIZES.forEach(s => (bedsBySize[s.key] = 0));
        els.bedsSizeInputs.forEach(input => {
          const key = input.getAttribute("data-linen-par-beds-size");
          if (!key) return;
          bedsBySize[key] = clamp(parseFloat(input.value), 0, 1000000);
        });
        return bedsBySize;
      }

      function readState() {
        return {
          bedsBySize: getBedsBySize(),
          occPct: clamp(parseFloat(els.occ.value), 0, 100),
          par: clamp(parseFloat(els.par.value), 1, 4),
          bufferPct: clamp(parseFloat(els.buffer.value), 0, 50),
          flatPerBed: clamp(parseFloat(els.flat.value), 0, 10),
          fittedPerBed: clamp(parseFloat(els.fitted.value), 0, 10),
          pcasesPerBed: clamp(parseFloat(els.pcases.value), 0, 10),
        };
      }

      function computeOutputs(state) {
        const multiplier = 1 + (state.bufferPct / 100);
        const bySize = {};
        let totalBeds = 0;
        let activeBeds = 0;
        const totals = { flat: 0, fitted: 0, pillowcases: 0, all: 0 };

        SIZES.forEach(s => {
          const beds = state.bedsBySize[s.key] || 0;
          totalBeds += beds;

          const active = beds * (state.occPct / 100);
          activeBeds += active;

          const bedSets = active * state.par;

          const flat = bedSets * state.flatPerBed * multiplier;
          const fitted = bedSets * state.fittedPerBed * multiplier;
          const pillowcases = bedSets * state.pcasesPerBed * multiplier;
          const total = flat + fitted + pillowcases;

          bySize[s.key] = { flat, fitted, pillowcases, total };
          totals.flat += flat;
          totals.fitted += fitted;
          totals.pillowcases += pillowcases;
          totals.all += total;
        });

        return { bySize, totals, totalBeds, activeBeds };
      }

      function render(state, outputs) {
        if (els.outTotalBeds) els.outTotalBeds.textContent = fmt(outputs.totalBeds);
        if (els.outActiveBeds) els.outActiveBeds.textContent = fmt(outputs.activeBeds);

        const setCells = (tag, val) => {
          const cells = outMapMulti.get(tag) || [];
          cells.forEach(c => (c.textContent = fmt(val)));
        };

        SIZES.forEach(s => {
          const o = outputs.bySize[s.key];
          setCells(`${s.key}:flat`, o.flat);
          setCells(`${s.key}:fitted`, o.fitted);
          setCells(`${s.key}:pillowcases`, o.pillowcases);
          setCells(`${s.key}:total`, o.total);
        });

        (els.outTotalsFlat || []).forEach(el => el.textContent = fmt(outputs.totals.flat));
        (els.outTotalsFitted || []).forEach(el => el.textContent = fmt(outputs.totals.fitted));
        (els.outTotalsPcases || []).forEach(el => el.textContent = fmt(outputs.totals.pillowcases));
        (els.outTotalsAll || []).forEach(el => el.textContent = fmt(outputs.totals.all));

        const suggested = parSuggestionFromOcc(state.occPct);
        if (els.parSuggestion) {
          els.parSuggestion.textContent = `Suggested par (based on ${roundInt(state.occPct)}% occupancy): ${suggested} par.`;
        }
      }

      function recalc() {
        const state = readState();
        const outputs = computeOutputs(state);
        render(state, outputs);
        return { state, outputs };
      }

      function applyPreset(key) {
        const preset = PRESETS[key];
        if (!preset) return;
        els.flat.value = preset.flat;
        els.fitted.value = preset.fitted;
        if (!Number.isFinite(parseFloat(els.pcases.value))) els.pcases.value = preset.pillowcases ?? 2;
        recalc();
      }

      function resetAll() {
        els.bedsSizeInputs.forEach(i => (i.value = 0));
        els.occ.value = 80;
        els.par.value = 3;
        els.buffer.value = 5;
        if (els.preset) els.preset.value = "double_fitted_flat";
        els.pcases.value = 2;
        applyPreset("double_fitted_flat");
        if (els.copyStatus) els.copyStatus.textContent = "";
        if (els.occTooltip) els.occTooltip.hidden = true;
        setStep(1);
        recalc();
      }

      function copyResults() {
        const { state, outputs } = recalc();
        const text = buildCopyText(state, outputs);

        const ok = () => {
          if (els.copyStatus) els.copyStatus.textContent = "Copied to clipboard.";
          setTimeout(() => { if (els.copyStatus) els.copyStatus.textContent = ""; }, 2000);
        };

        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(text).then(ok).catch(() => {
            if (els.copyStatus) els.copyStatus.textContent = "Copy failed — please copy manually.";
          });
        } else {
          if (els.copyStatus) els.copyStatus.textContent = "Clipboard not available — please copy manually.";
        }
      }

      // Stepper
      els.stepPills.forEach(pill => pill.addEventListener("click", () => setStep(pill.getAttribute("data-step-pill"))));
      els.nextBtns.forEach(btn => btn.addEventListener("click", () => setStep(Math.min(3, parseInt(root.getAttribute("data-linen-step") || "1", 10) + 1))));
      els.prevBtns.forEach(btn => btn.addEventListener("click", () => setStep(Math.max(1, parseInt(root.getAttribute("data-linen-step") || "1", 10) - 1))));

      // Inputs
      if (els.preset) els.preset.addEventListener("change", e => applyPreset(e.target.value));
      [els.occ, els.par, els.buffer, els.flat, els.fitted, els.pcases, ...els.bedsSizeInputs]
        .filter(Boolean)
        .forEach(el => el.addEventListener("input", recalc));

      // Buttons (ALL)
      els.resetBtns.forEach(b => b.addEventListener("click", resetAll));
      els.copyBtns.forEach(b => b.addEventListener("click", copyResults));
      els.printBtns.forEach(b => b.addEventListener("click", () => window.print()));

      // Tooltip
      if (els.occInfoBtn) els.occInfoBtn.addEventListener("click", () => { if (els.occTooltip) els.occTooltip.hidden = !els.occTooltip.hidden; });
      document.addEventListener("click", (evt) => {
        if (!els.occTooltip || els.occTooltip.hidden) return;
        const clickedInside = els.occTooltip.contains(evt.target) || els.occInfoBtn?.contains(evt.target);
        if (!clickedInside) els.occTooltip.hidden = true;
      });

      // Init
      setStep(1);
      applyPreset(els.preset?.value || "double_fitted_flat");
      recalc();
    });
  });
})();